import { identity } from "lodash";
import React from "react";

export type FormGroupContextField = {
  colSpan: number; // final value
  name: string;
  info?: FormGroupContextFieldInfo;
};

export type FormGroupContextFieldInfo = {
  colSpan?: number | null; // requested value
  isHidden?: boolean;
};

export interface FormGroupContextProps {
  register: (name: string) => void;
  patch: (name: string, info: FormGroupContextFieldInfo) => void;
  unregister: (name: string) => void;

  fields: FormGroupContextField[];
}

export const FormGroupContext = React.createContext<FormGroupContextProps>({
  fields: [],
  register: identity,
  patch: identity,
  unregister: identity
});
